class RawWebSocket {
  socket = null;
  url = null;
  listeners = {};
  isConnected = false;
  reconnectTimer = null;
  reconnectDelay = 2000;
  maxDelay = 15000;
  Id = null;

  connect(url, id) {
    if (this.socket) return; // prevent multiple instances
    this.Id = id;
    this.url = url;
    this.socket = new WebSocket(url);

    this.socket.onopen = () => {
      console.log("WS Connected", url);
      try {
        if (id)
          this.socket.send(
            JSON.stringify({
              event: "subscribe",
              user_id: id,
            }),
          );
        this.isConnected = true;
        this.reconnectDelay = 2000;
        if (this.listeners["connected"]) {
          this.listeners["connected"].forEach((cb) => cb());
        }
      } catch (error) {
        console.error("socker", error);
      }
    };

    this.socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log(" WS message received", data);

        if (data.event && this.listeners[data.event]) {
          this.listeners[data.event].forEach((cb) => cb(data));
        }
      } catch (e) {
        console.log("Invalid WS message", e, event);
      }
    };

    this.socket.onerror = (e) => {
      console.log("WS Error:", e);
    };

    this.socket.onclose = () => {
      console.log("WS Closed");
      this.isConnected = false;
      this.socket = null;
      this.reconnect();
    };
  }

  reconnect() {
    if (!this.url) return;

    clearTimeout(this.reconnectTimer);

    this.reconnectTimer = setTimeout(() => {
      console.log("Reconnecting...");
      this.connect(this.url, this.Id);
      this.reconnectDelay = Math.min(this.reconnectDelay * 2, this.maxDelay);
    }, this.reconnectDelay);
  }

  emit(event, data) {
    if (!this.isConnected || !this.socket) return;
    console.log("data to emit", {
      event,
      data,
    });
    this.socket.send(
      JSON.stringify({
        event,
        data,
      }),
    );
  }

  listen(channel, callback) {
    if (!this.listeners[channel]) {
      this.listeners[channel] = [];
    }
    this.listeners[channel].push(callback);
  }

  leave(channel) {
    if (this.listeners[channel]) {
      delete this.listeners[channel];
    }
  }

  clearListeners() {
    this.listeners = {};
  }

  disconnect() {
    clearTimeout(this.reconnectTimer);
    if (this.socket) {
      this.socket.close();
      this.socket = null;
      this.url = null;
    }
    console.log("socket disconnected");
    this.isConnected = false;
  }
}

export default new RawWebSocket();
